import { render } from "./Homepage.vue?vue&type=template&id=4f977df8"
import script from "./Homepage.vue?vue&type=script&lang=js"
export * from "./Homepage.vue?vue&type=script&lang=js"

import "./Homepage.vue?vue&type=style&index=0&id=4f977df8&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__